export default "__VITE_ASSET__c8ce2ef5__"